import HttpClient from '@/util/http/HttpClient';
import GraphQlApi from '@/repositories/api/GraphQlApi';
import GlobalViewModel from '@/state/GlobalViewModel';
import GlossRepository from '@/repositories/GlossRepository';
import ReferenceDataRepository from '@/repositories/ReferenceDataRepository';
import ModuleRepository from '@/repositories/ModuleRepository';
import UserRepository from '@/repositories/UserRepository';
import SignApi from '@/repositories/api/SignApi';
import MapService from '@/state/MapService';
import UserApi from '@/repositories/api/UserApi';

const owEndpoint = process.env.VUE_APP_OW_ENDPOINT as string;
const apiEndpoint = owEndpoint + '/api';
export const mediaEndpoint = apiEndpoint;
const loginEndpoint = owEndpoint + '/oauth2/authorization/ngc-auth';
const logoutEndpoint = owEndpoint + '/oauth2/logout';
const httpClient = new HttpClient({});
const graphQlApi = new GraphQlApi(httpClient, apiEndpoint);
const signApi = new SignApi(httpClient, apiEndpoint);
const userApi = new UserApi(httpClient, apiEndpoint, logoutEndpoint);
const userRepository = new UserRepository(userApi, graphQlApi);
export const glossRepository = new GlossRepository(graphQlApi, signApi);
export const referenceDataRepository = new ReferenceDataRepository(graphQlApi);
export const moduleRepository = new ModuleRepository(graphQlApi);
export const globalViewModel = new GlobalViewModel(userRepository, loginEndpoint);
httpClient.registerRawRequestMiddleware(globalViewModel);
httpClient.registerRawResponseMiddleware(globalViewModel);
export const mapService = new MapService(
    process.env.VUE_APP_GOOGLE_MAPS_API_KEY!,
    process.env.VUE_APP_GOOGLE_MAPS_MAP_ID!,
);
